export default function(opts) {
    opts  = $.extend( true, {
        title     : 'Are you sure?',
        message   : '',
        okButton  : 'OK',
        okIcon    : 'trash',
        noButton  : 'Cancel',
        callback  : $.noop,
        closeButton : false
    }, opts || {} );

    $.fancybox.open({
        type : 'html',
        src  : `
            <div class="fc-content">
                <h3>${opts.title}</h3>
                <p>${opts.message}</p>
                <div class="buttons-inline">
                    <button data-value="0" data-fancybox-close class="btn btn--small btn--transparent">${opts.noButton}</button>
                    <button data-value="1" data-fancybox-close class="btn btn--small btn--red">${opts.okButton}</button>
                </div>
            </div>`,
        opts : {
            animationDuration : 350,
            animationEffect   : 'material',
            modal : false,
            afterClose : function( instance, current, e ) {
                let button = e ? e.target || e.currentTarget : null;
                let value  = button ? $(button).data('value') : 0;

                opts.callback( value );
            }
        }
    });
};



// WEBPACK FOOTER //
// ./src/assets/js/plugins/FancyConfirm.js